import React from "react";

import { LinkPassableProps, MoveablePassableProps } from "@multiweb/picasso";
import { Activity, Set, Transition } from "./picassoComponents";

/** Vrací Aktivitu/Sadu pro piccaso komponentu Moveable. */
export const moveableRenderer = (name: string, props: MoveablePassableProps): JSX.Element => {
    if (name === "activity")
        return (React.createElement(Activity, props, null));
    return (React.createElement(Set, props, null));
};

/** Vrací komponentu (ve WF propojení) reprezentující picasso Link. */
export const linkRenderer = (_name: string, props: LinkPassableProps): JSX.Element => {
    return (React.createElement(Transition, props, null));
};
